import Swal from 'sweetalert2';

// The "OTP Authentication in progress" popup waits on the bot. It is shown for at most 30 minutes
// from the upload (across page reloads); after that it closes and the batch flags are cleared.
export const OTP_POPUP_MAX_MS = 30 * 60 * 1000;

const SINCE_KEY = 'bulkUploadProcessingSince';

export const startOtpProcessing = () => {
    localStorage.setItem('isBulkUploadProcessing', 'true');
    localStorage.setItem(SINCE_KEY, String(Date.now()));
};

export const clearOtpProcessing = () => {
    localStorage.removeItem('isBulkUploadProcessing');
    localStorage.removeItem('currentBatchPatientIds');
    localStorage.removeItem('currentBatchInsuranceName');
    localStorage.removeItem(SINCE_KEY);
};

// Time the popup may still stay open; 0 when nothing is processing or the 30 minutes are up
// (a flag left without a start time is from before this limit and is treated as expired)
export const otpProcessingTimeLeft = (): number => {
    if (localStorage.getItem('isBulkUploadProcessing') !== 'true') return 0;
    const since = Number(localStorage.getItem(SINCE_KEY));
    const left = since ? since + OTP_POPUP_MAX_MS - Date.now() : 0;
    if (left <= 0) {
        clearOtpProcessing();
        return 0;
    }
    return Math.min(left, OTP_POPUP_MAX_MS);
};

// Pass to the popup's .then(): clears the batch flags when it closed because its time ran out
export const onOtpPopupClosed = (result: { dismiss?: unknown }) => {
    if (result.dismiss === Swal.DismissReason.timer) clearOtpProcessing();
};
